import React, { useState, useEffect, useRef } from 'react'
import styles from "./thewhy.module.css"
import mountain from "../assets/The_Why_Page/2x/mountainupdated.png"
import cactus from "../assets/The_Why_Page/2x/cactusupdated.png"
import childage from "../assets/The_Why_Page/2x/children_ageupdated.png"
import us from "../assets/The_Why_Page/2x/usupdated.png"
import uk from "../assets/The_Why_Page/2x/ukupdated.png"
import canada from "../assets/The_Why_Page/2x/canadaupdated.png"
import australia from "../assets/The_Why_Page/2x/australia.png"
import icongreen from "../assets/The_Why_Page/2x/icongreen.png"
import dryball from "../assets/The_Why_Page/2x/dryball.png"
import bigrock from "../assets/The_Why_Page/2x/bigrock.png"
import drytree from "../assets/The_Why_Page/2x/drytree.png"
import leftrose from "../assets/The_Why_Page/2x/leftrose.png"
import scorpio from "../assets/The_Why_Page/2x/scorpio.png"
import longboard from "../assets/The_Why_Page/2x/longboardupdated.png"
import rightrose from "../assets/The_Why_Page/2x/rightrose.png"
import board1 from "../assets/WhatWeDoPageAssets/1x/Asset 33@2x.png"
import board2 from "../assets/WhatWeDoPageAssets/1x/Asset 38@2x.png"
import board3 from "../assets/WhatWeDoPageAssets/1x/Asset 32@2x.png"
import board4 from "../assets/WhatWeDoPageAssets/1x/Asset 34@2x.png"
import board5 from "../assets/WhatWeDoPageAssets/1x/Asset 36@2x.png"
import { Helmet } from "react-helmet-async";
function Thewhy() {
  // Popover anchored beside clicked info icon (keeps image next to icon like WhatWeDo)
  const anchorRef = useRef(null);
  const popoverRef = useRef(null);
  const [popover, setPopover] = useState({ open: false, img: null, top: 0, left: 0, caption: null, captionClass: null });

  const openLightbox = (evt, img) => {
    const target = evt.currentTarget;
    // If clicking the same icon while popover is open, toggle it closed
    if (popover.open && anchorRef.current === target) {
      closePopover();
      return;
    }
    anchorRef.current = target;
    try {
      // Only scroll the icon into view if it's not fully visible to avoid page
      // jumping/shaking when opening the popover.
      const _rect = target.getBoundingClientRect();
      const isFullyVisible = _rect.top >= 0 && _rect.bottom <= window.innerHeight;
      if (!isFullyVisible) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    } catch (e) { }
    const rect = evt.currentTarget.getBoundingClientRect();
    const gap = 12;
    const assumedMaxWidth = 360;
    const left = Math.min(rect.right + gap, window.innerWidth - assumedMaxWidth - 8);
    const top = rect.top + rect.height / 2;
    // Determine caption + captionClass based on which board image is being shown
    let caption = null;
    let captionClass = null;
    if (img === board1) { caption = 'Source: National Health Service'; captionClass = 'captionBoard1'; }
    else if (img === board2) { caption = 'Source: Centers for Disease Control and Prevention'; captionClass = 'captionBoard2'; }
    else if (img === board3) { caption = 'Source: Smiling Mind'; captionClass = 'captionBoard3'; }
    else if (img === board4) { caption = 'Source: Australian Institute of Health and Welfare'; captionClass = 'captionBoard4'; }
    else if (img === board5) { caption = 'Source: Statistics Canada'; captionClass = 'captionBoard5'; }

    setPopover({ open: true, img, top, left, caption, captionClass });
  };

  const closePopover = () => setPopover({ open: false, img: null, top: 0, left: 0, caption: null, captionClass: null });

  useEffect(() => {
    if (!popover.open) return;
    const onKey = (e) => { if (e.key === 'Escape') closePopover(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [popover.open]);

  useEffect(() => {
    if (!popover.open) return;
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        closePopover();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [popover.open]);

  // Recalculate position on scroll/resize so popover stays beside the icon
  useEffect(() => {
    if (!popover.open) return;
    const rePos = () => {
      if (!anchorRef.current) return;
      const rect = anchorRef.current.getBoundingClientRect();
      const gap = 12;
      const assumedMaxWidth = 360;
      const left = Math.min(rect.right + gap, window.innerWidth - assumedMaxWidth - 8);
      const top = rect.top + rect.height / 2;
      setPopover(p => ({ ...p, top, left }));
    };
    window.addEventListener('scroll', rePos, { passive: true, capture: true });
    window.addEventListener('resize', rePos, { passive: true });
    rePos();
    return () => {
      window.removeEventListener('scroll', rePos, true);
      window.removeEventListener('resize', rePos);
    };
  }, [popover.open]);

  return (
    <>
   <Helmet>
  <title>
    Kids Mental Health Is Declining | Our Children Need Us
  </title>

  <meta
    name="description"
    content="Screen time still isn’t decreasing — but it can be better. Explore Jungle Morals’ kids stories, songs, and learning videos that teach real-life values."
  />

  <meta name="robots" content="index, follow" />

  <link
    rel="canonical"
    href="https://www.junglemorals.com/thewhy"
  />

  {/* Open Graph */}
  <meta
    property="og:title"
    content="Kids Mental Health Is Declining | Our Children Need Us"
  />

  <meta
    property="og:description"
    content="Screen time still isn’t decreasing — but it can be better. Explore Jungle Morals’ kids stories, songs, and learning videos that teach real-life values."
  />

  <meta
    property="og:url"
    content="https://www.junglemorals.com/thewhy"
  />

  <meta property="og:type" content="website" />

  <meta
    property="og:image"
    content="https://www.junglemorals.com/static/media/bigrock.566f25824d3c44e007b9.png"
  />

  {/* Twitter */}
  <meta
    name="twitter:card"
    content="summary_large_image"
  />

  <meta
    name="twitter:title"
    content="Kids Mental Health Is Declining | Our Children Need Us"
  />

  <meta
    name="twitter:description"
    content="Screen time still isn’t decreasing — but it can be better. Explore Jungle Morals’ kids stories, songs, and learning videos that teach real-life values."
  />

  <meta
    name="twitter:image"
    content="https://www.junglemorals.com/static/media/bigrock.566f25824d3c44e007b9.png"
  />

  {/* Schema */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://www.junglemorals.com/#organization",
          name: "Jungle Morals",
          url: "https://www.junglemorals.com/",
          logo: {
            "@type": "ImageObject",
            url: "https://www.junglemorals.com/static/media/logo.webp"
          }
        },
        {
          "@type": "WebSite",
          "@id": "https://www.junglemorals.com/#website",
          url: "https://www.junglemorals.com/",
          name: "Jungle Morals",
          publisher: {
            "@id": "https://www.junglemorals.com/#organization"
          }
        },
        {
          "@type": "WebPage",
          "@id": "https://www.junglemorals.com/thewhy#webpage",
          url: "https://www.junglemorals.com/thewhy",
          name: "Kids Mental Health Is Declining | Our Children Need Us",
          headline: "Our Children Need Us",
          description:
            "Screen time still isn’t decreasing — but it can be better. Explore Jungle Morals’ kids stories, songs, and learning videos that teach real-life values.",
          inLanguage: "en",
          isPartOf: {
            "@id": "https://www.junglemorals.com/#website"
          },
          about: {
            "@type": "Thing",
            name: "Children's mental health and screen time"
          },
          publisher: {
            "@id": "https://www.junglemorals.com/#organization"
          },
          primaryImageOfPage: {
            "@type": "ImageObject",
            url: "https://www.junglemorals.com/static/media/bigrock.566f25824d3c44e007b9.png"
          },
          breadcrumb: {
            "@id": "https://www.junglemorals.com/thewhy#breadcrumb"
          }
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.junglemorals.com/thewhy#breadcrumb",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://www.junglemorals.com/"
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "The Why",
              item: "https://www.junglemorals.com/thewhy"
            }
          ]
        }
      ]
    })}
  </script>
</Helmet>
    <div className={styles.mainwhy} style={{ marginTop: '-2vw',marginBottom:'-18vw',position:'relative', zIndex:'11'}}> 
      <div className={styles.thewhycontainer}>


        <img src={mountain} className={styles.mountain} alt="Cartoon desert sand dunes background in warm golden colors" />

        <img src={dryball} alt="Cartoon tumbleweed made of dry tangled branches in desert scene" className={styles.dryball1} />
        <img src={cactus} alt="Sad cartoon cactus characters holding blank banner in desert scene for message or title" className={styles.cactus} />
        <h1 className={` font-adventuring ${styles.heading}`}>Our Children Need Us</h1>
        {/* ////////////////////////firstgraph//////////////////////// */}
        <div className={styles.firstgraph}>
          <h3 className={`font-brandon ${styles.firstgraphtext1}`}>Well-being declines as children age</h3>
          <img src={childage} alt='Bar chart showing increasing values from 34 to 54 indicating upward growth trend' className={styles.childbar} />
          <img
            src={icongreen}
            alt="Information Icon"
            className={styles.icongreen}
            role='button'
            tabIndex={0}
            onClick={(e) => openLightbox(e, board3)}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openLightbox(e, board3) }}
          />
          <div className={styles.agelabels}>
            <h6>4 year old</h6>
            <h6>5 year old</h6>
            <h6>6 year old</h6>
            <h6>7 year old</h6>
            <h6>8 year old</h6>
            <h6>9 year old</h6>
            <h6>10 year old</h6>
          </div>

          <h6 className={`font-brandon ${styles.firstgraphtext2}`}>Preventive mental health measures should be introduced early</h6>
          <h6 className={`font-brandon ${styles.firstgraphtext3}`}>Approximate percentages based on Smiling Mind State of Mind Report 2024</h6>
          <h3 className={`font-brandon ${styles.firstgraphtext4}`}>%age of children exhibiting low levels of well-being</h3>
          <h3 className={styles.firstgraphtext5}>
            <div class="num n60">60</div>
            <div class="num n50">50</div>
            <div class="num n40">40</div>
            <div class="num n30">30</div>
            <div class="num n20">20</div>
            <div class="num n10">10</div>
            <div class="num n0">0</div>
          </h3>

        </div>

        <img src={dryball} alt="Cartoon tumbleweed made of dry tangled branches in desert scene" className={styles.dryball2} />
        <img src={dryball} alt="Cartoon tumbleweed made of dry tangled branches in desert scene" className={styles.dryball3} />


        {/* //////////////////////// usgraph//////////////////////// */}
        <div className={styles.usgraph}>
          <h3 className={styles.ush3graphtext1}>UNITED STATES</h3>
          <h3 className={`font-brandon ${styles.usgraphtext1}`}>Children need mental health support</h3>
          <img src={icongreen} alt="Information Icon" className={styles.icongreen2}
            role='button'
            tabIndex={0}
            onClick={(e) => openLightbox(e, board2)}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openLightbox(e, board2) }}
          />
          <h3 className={`font-brandon ${styles.usgraphtext2}`}>Among children aged 5-11 years</h3>
          <img src={us} alt="United States Bar chart comparing three values 11.3, 5.9 and 8.7 with highest at 11.3 and lowest at 5.9" className={styles.usimg} />
          <div className={styles.uslabels}>
            <h6>Any mental <br /> health treatment</h6>
            <h6>Took medication</h6>
            <h6>Received counseling <br /> or therapy</h6>
          </div>


          <h6 className={`font-brandon ${styles.usgraphtext3}`}>Approximate percentages based on CDC National Health Interview Survey</h6>
          <h3 className={`font-brandon ${styles.usgraphtext4}`}>%age of children needing mental health support</h3>
          <h3 className={styles.usgraphtext5}>
            <div class="num n60">12</div>
            <div class="num n50">10</div>
            <div class="num n40">8</div>
            <div class="num n30">6</div>
            <div class="num n20">4</div>
            <div class="num n10">2</div>
            <div class="num n0">0</div>
          </h3>
        </div>

 
        {/* //////////////////////ukgraph//////////////////////// */}
        <div className={styles.ukgraph}>
          <img src={uk} alt="United Kingdom Bar chart comparing three values 11.3, 5.9 and 8.7 with highest at 11.3 and lowest at 5.9" className={styles.ukimg} />
          <h3 className={styles.ukh3graphtext1}>UNITED KINGDOM</h3>
          <h3 className={`font-brandon ${styles.ukgraphtext1}`}>Rise in Mental Health Challenges</h3>
          <h3 className={`font-brandon ${styles.ukgraphtext2}`}>Among children aged 8-16 years</h3>
          <img src={icongreen}
            alt="Information Icon"
            className={styles.icongreen3}
            role='button'
            tabIndex={0}
            onClick={(e) => openLightbox(e, board1)}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openLightbox(e, board1) }}
          />
          <h3 className={`font-brandon ${styles.ukgraphtext4}`}>%age of children facing mental health challenges</h3>
          <h6 className={`font-brandon ${styles.ukgraphtext3}`}>Approximate percentages based on national survey data, NHS England</h6>
          <h3 className={styles.ukgraphtext5}>
            <div class="num n40">20</div>
            <div class="num n30">15</div>
            <div class="num n20">10</div>
            <div class="num n10">5</div>
            <div class="num n0">0</div>
          </h3>
          <div className={styles.uklabels}>
            <h6>2017</h6>

            <h6>2023</h6>
          </div>
        </div>
        {/* ////////////////////AUSTRALIA GRAPH /////////////////////  */}
        <div className={styles.australiagraph}>
          <h3 className={styles.aush3graphtext1}>AUSTRALIA</h3>
          <h3 className={`font-brandon ${styles.australiagraphtext1}`}>Prevalence of mental health disorder</h3>
          <img src={icongreen} alt="Information Icon" className={styles.icongreen4}
            role='button'
            tabIndex={0}
            onClick={(e) => openLightbox(e, board4)}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openLightbox(e, board4) }}
          />
          <h3 className={`font-brandon ${styles.australiagraphtext2}`}>Among children aged 4-17 years</h3>
          <h3 className={`font-brandon ${styles.australiagraphtext3}`}>~14% experienced a  <br />mental disorder</h3>
          <h3 className={`font-brandon ${styles.australiagraphtext4}`}>Approximate percentages based on Australian Child Mental-health Survey</h3>
          <img src={australia} alt="Australia Pie chart showing majority portion around 85 percent and smaller segment around 15 percent" className={styles.australia} />
        </div>

        {/* //////////////////////////////canada graph//////////////////////// */}


        <div className={styles.canadagraph}>
          <img src={canada} alt="Canada Bar chart comparing two values 12 and 25 showing second value significantly higher" className={styles.canada} />
          <h3 className={styles.canh3graphtext1}>CANADA</h3>
          <h3 className={`font-brandon ${styles.canadagraphtext1}`}>Growing mental health concerns among youth</h3>
          <img src={icongreen} alt="Information Icon" className={styles.icongreen5}
            role='button'
            tabIndex={0}
            onClick={(e) => openLightbox(e, board5)}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openLightbox(e, board5) }}
          />
          <h3 className={`font-brandon ${styles.cagraphtext2}`}>Among children aged 12-17 years</h3>

          <h6 className={`font-brandon ${styles.canadagraphtext3}`}>Approximate percentages based on National Survey Data, Statistics Canada</h6>
          <h3 className={`font-brandon ${styles.canadagraphtext4}`}>%age of children with growing mental health concerns</h3>
          <h3 className={styles.canadagraphtext5}>

            <div class="num n50">25</div>
            <div class="num n40">20</div>
            <div class="num n30">15</div>
            <div class="num n20">10</div>
            <div class="num n10">5</div>
            <div class="num n0">0</div>
          </h3>
          <div className={styles.canadalabels}>
            <h6>2018-19</h6>
            <h6>2021-23</h6>
          </div>
          {/* <p className={styles.candata}>Approximate percentages based on National Survey Data, Statistics Canada</p> */}
        </div>

        <img src={bigrock} alt="Large desert rock with dry plants and sparse vegetation in arid landscape" className={styles.bigrock} />

        <p className={`font-brandon ${styles.bigrocktext1}`}><strong className={styles.strongtext} >Screens</strong> have become an <br />
          <strong className={styles.strongtext}>unavoidable</strong> part of children’s daily <br />
          routines, shaped by modern <strong className={styles.strongtext}>learning</strong>, <br />
          <strong className={styles.strongtext}>entertainment</strong>, and reduced outdoor <br />
          engagement. <br />
        </p>
        <p className={`font-brandon ${styles.bigrocktext2}`}>
          The growing reliance on <br />
          digital devices has been associated with <br />
          <strong className={styles.strongtext}>disrupted sleep</strong>, reduced in-person <br />
          social interaction, and increased <strong className={styles.strongtext}>emotional</strong> <br />
          <strong className={styles.strongtext}>challenges</strong> such as <strong className={styles.strongtext}>anxiety</strong>, low mood, <br />
          and feelings of <strong className={styles.strongtext}>loneliness</strong></p>


        <img src={drytree} alt="Dry leafless branches with small green plants in arid desert environment" className={styles.drytree} />
        <img src={leftrose} alt="Cute smiling cartoon red rose flower with face and green leaves" className={styles.leftrose} />
        <img src={rightrose} alt="Cute smiling cartoon red rose flower with face and green leaves" className={styles.rightrose} />
        <img src={longboard} alt="Blank wooden signboard frame for text or message display" className={styles.longboard} />
        <article className={` font-brandon ${styles.article}`}>Screens aren’t going anywhere—they’re becoming <br />
          an even bigger part of childhood. <br />
          <strong className={styles.strongtext}>Jungle Morals</strong> focuses on <strong className={styles.strongtext}>improving the quality </strong>of <br />
          that <strong className={styles.strongtext}>screen time</strong>. Through <strong className={styles.strongtext}>thoughtful content</strong>, we aim to <br />
          give children the emotional tools to navigate an ever - <br />
          changing world with <strong className={styles.strongtext}>calm</strong>, confidence, and <strong className={styles.strongtext}>joy</strong>.</article>

        <img src={scorpio} alt="Happy cartoon scorpion holding Jungle Morals signboard in kids style" className={styles.scorpio} />

      {popover.open && (
  <>
    {/* 🔥 BACKGROUND OVERLAY (SIRF YE ADD HUA HAI) */}
    <div
      className={styles.popoverOverlay}
      onClick={closePopover} // agar bahar click pe close chahiye
    />

    {/* ❗ TERA EXISTING POPOVER — NO CHANGE */}
    <div
      className={styles.popoverRoot}
      style={{ top: `${popover.top}px`, left: `${popover.left}px` }}
      role="dialog"
      aria-modal="false"
    >
      <div
        ref={popoverRef}
        className={styles.popoverCard}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.popoverImgWrap}>
          {popover.img === board1 ? (
            <a
              href="https://digital.nhs.uk/data-and-information/publications/statistical/mental-health-of-children-and-young-people-in-england/2023-wave-4-follow-up"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={popover.img} alt="enlarged-board" className={styles.popoverImg} />
            </a>
          ) : popover.img === board2 ? (
            <a
              href="https://www.cdc.gov/nchs/products/databriefs/db472.htm"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={popover.img} alt="enlarged-board" className={styles.popoverImg} />
            </a>
          ) : popover.img === board4 ? (
            <a
              href="https://www.aihw.gov.au/reports/children-youth/australias-children/contents/health/children-mental-illness"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={popover.img} alt="enlarged-board" className={styles.popoverImg} />
            </a>
          ) : popover.img === board5 ? (
            <a
              href="https://www.statcan.gc.ca/o1/en/plus/7642-rising-mental-health-concerns-among-youth"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={popover.img} alt="enlarged-board" className={styles.popoverImg} />
            </a>
          ) : (
            <img src={popover.img} alt="enlarged-board" className={styles.popoverImg} />
          )}

          {popover.caption && (
            popover.captionClass === 'captionBoard1' ||
            popover.caption.includes('National Health Service') ? (
              <a
                href="https://digital.nhs.uk/data-and-information/publications/statistical/mental-health-of-children-and-young-people-in-england/2023-wave-4-follow-up"
                target="_blank"
                rel="noopener noreferrer"
                className={`font-adventuring ${styles.popoverCaption} ${styles.captionBoard1}`}
              >
                {popover.caption}
              </a>
            ) : popover.captionClass === 'captionBoard3' ||
              popover.caption.includes('Smiling Mind') ? (
              <a
                href="https://info.smilingmind.com.au/hubfs/Research/State%20of%20Mind/State%20of%20Mind%202024/SmilingMind_State_of_Mind_Report_2024.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className={`font-adventuring ${styles.popoverCaption} ${styles.captionBoard3}`}
              >
                {popover.caption}
              </a>
            ) : popover.captionClass === 'captionBoard4' ? (
              <a
                href="https://www.aihw.gov.au/reports/children-youth/australias-children/contents/health/children-mental-illness"
                target="_blank"
                rel="noopener noreferrer"
                className={`font-adventuring ${styles.popoverCaption} ${styles.captionBoard4}`}
              >
                {popover.caption}
              </a>
            ) : popover.captionClass === 'captionBoard5' ? (
              <a
                href="https://www.statcan.gc.ca/o1/en/plus/7642-rising-mental-health-concerns-among-youth"
                target="_blank"
                rel="noopener noreferrer"
                className={`font-adventuring ${styles.popoverCaption} ${styles.captionBoard5}`}
              >
                {popover.caption}
              </a>
            ) : popover.captionClass === 'captionBoard2' ? (
              <a
                href="https://www.cdc.gov/nchs/products/databriefs/db472.htm"
                target="_blank"
                rel="noopener noreferrer"
                className={`font-adventuring ${styles.popoverCaption} ${styles.captionBoard2}`}
              >
                {popover.caption}
              </a>
            ) : (
              <div className={`font-adventuring ${styles.popoverCaption}`}>
                {popover.caption}
              </div>
            )
          )}
        </div>
      </div>
    </div>
  </>
)}

      </div>
      </div>
    </>

  )
}

export default Thewhy